$(() => {
    const $accountLink = $('.sc-account-link');
    let accountLink = $accountLink.attr('href');
    accountLink = accountLink.replace('locale=en', 'locale=' + document.documentElement.lang);
    $accountLink.attr('href', accountLink);

    $(document).on('click', '.sc-product-card, .sc-article-card', function(e) {
        const tag = e.target.tagName.toLowerCase();
        if (tag !== 'a' && tag !== 'svg' && tag !== 'button') {
            location.href = $(this).find('a').first().attr('href');
        }
    });

    // hover effect for an article cover: show a quick video
    $('.sc-articles a > div:first-child').hover(function () {
        const video = this.querySelector('video');
        if (video) {
            video.style.display = 'block';
            video.play();
        }
    }, function () {
        const video = this.querySelector('video');
        if (video) {
            video.style.display = 'none';
            video.pause();
        }
    });

    const urlParams = new URLSearchParams(window.location.search);

    if (urlParams.get('email')) {
        const modal = document.getElementById('sc-newsletter-dialog');
        modal.showModal();

        setTimeout(function () {
            modal.close();

            const source = urlParams.get('source');
            const offset = 360;
            if (source === 'block') {
                window.scrollTo(0, $('#newsletter-block').offset().top - offset);
            } else if (source === 'footer') {
                window.scrollTo(0, $('#newsletter-footer').offset().top - offset);
            }
        }, 3000);
    }

    const arrow = $('.klaviyo-form').data('arrow');
    $('.klaviyo-form button').css('background-image', `url(${arrow})`);
});